import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '../../base/styled/variables.styled';
const StyledSvg = styled.svg `
  width: ${props => props.width || '14px'};
  height: ${props => props.height || '14px'};

  path {
    fill: ${props => props.color || colors.neutral800};
  }
`;
const LogoutIcon = ({ color, width, height }) => {
    return (_jsx(StyledSvg, { width: width, height: height, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: color, children: _jsx("path", { d: "M2.66675 10.9999H4.00008V12.3333H12.0001V1.66659H4.00008V2.99992H2.66675V0.999919C2.66675 0.823108 2.73699 0.653538 2.86201 0.528514C2.98703 0.40349 3.1566 0.333252 3.33341 0.333252H12.6667C12.8436 0.333252 13.0131 0.40349 13.1382 0.528514C13.2632 0.653538 13.3334 0.823108 13.3334 0.999919V12.9999C13.3334 13.1767 13.2632 13.3463 13.1382 13.4713C13.0131 13.5963 12.8436 13.6666 12.6667 13.6666H3.33341C3.1566 13.6666 2.98703 13.5963 2.86201 13.4713C2.73699 13.3463 2.66675 13.1767 2.66675 12.9999V10.9999ZM4.00008 6.33325H8.66675V7.66659H4.00008V9.66659L0.666748 6.99992L4.00008 4.33325V6.33325Z", fill: color }) }));
};
export default LogoutIcon;
//# sourceMappingURL=LogoutIcon.js.map